<template>
	<div class="watch-readings-latest-modal">
		<modal-box v-if="modalBox.open" @close="onModalBoxClose" :header="$t('headers.general.position')">
			<div class="modal-reading modal-reading-map" v-if="reading">
				<h2 class="date-time">{{ dateTime }} ({{ timeAgo }})</h2>
				<h1>{{ reading.values.latitude }} <small>lat</small><br>{{ reading.values.longitude }} <small>lng</small></h1>
				<google-map v-if="reading" :reading="mapReading" :mapOptions="mapOptions"/>
			</div>
		</modal-box>
	</div>
</template>

<script>
import GoogleMap from '@/components/maps/GoogleMap'
export default {
	components: {
		GoogleMap
	},
	data () {
		return {
			reading: null,
			mapOptions: {
				zoom: 16,
				mapTypeControl: false,
				scaleControl: false,
				streetViewControl: false,
				rotateControl: false,
				fullscreenControl: false,
				zoomControl: false,
				draggable: false
			},
			modalBox: {
				open: false
			}
		}
	},
	computed: {
		dateTime () {
			return this.$moment(this.reading.datetime).format('DD MMM HH:mm')
		},
		timeAgo () {
			return this.$moment(this.reading.datetime).fromNow()
		},
		mapReading () {
			return {
				date: this.reading.datetime,
				position: [ this.reading.values.latitude, this.reading.values.longitude ]
			}
		}
	},
	methods: {
		onModalBoxClose () {
			this.modalBox.open = false
			this.reading = null
		},
		onModalBoxOpen (reading) {
			this.reading = reading
			this.modalBox.open = true
		}
	},
	created () {
		this.$parent.$on('open-modal', this.onModalBoxOpen)
	},
	beforeDestroy () {
		this.$parent.$off('open-modal', this.onModalBoxOpen)
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/readings/shared/widgets/modal/ModalBoxGeofencing.vue